<template>
  <div class="container as-flex main-start">
    <div class="side-bar" v-if="showBar">
      <sideBar></sideBar>
    </div>
    <div class="top-bar" v-if="showBar">
      <topBar></topBar>
    </div>
    <div :class="['content',showBar?'':'noBarContent']">
      <router-view class="router-view"></router-view>
    </div>
  </div>
</template>

<script>
import axiosCustomizeConf from "./utils/axios_customize_conf";
import { mapGetters } from "vuex";
import sideBar from "./components/sideBar.vue";
import topBar from "./components/topBar.vue";
export default {
  name: "App",
  components: {
    sideBar: sideBar,
    topBar: topBar
  },
  data() {
    return {
      showBar: true,
      error: undefined,
      navs: []
    };
  },
  methods: {
    notLoginMethod() {
      if (this.$route.path === "/login") {
        return;
      }
      this.$router.push({
        name: "login",
        query: { redirect: this.$route.fullPath }
      });
    },
    judgeBarShow(pathname) {
      if (pathname === "login") {
        this.showBar = false;
      } else {
        this.showBar = true;
      }
    }
    // FIXME: 目前的遍历处理的方式并不好，有待优化
    // 根据role转换nav
    // _transformNavList(role_name) {}
  },
  computed: {
    ...mapGetters({
      USER_INFO: "user/getUserInfo",
      LOGGIN_STATUS: "user/isLogined"
    })
  },
  created() {
    this.judgeBarShow(this.$route.name);
    axiosCustomizeConf.call(this);
    this.$store.commit("tabpage/initTabs");
  },
  mounted() {},
  watch: {
    LOGGIN_STATUS: function(to, from) {
      if (!to) {
        this.notLoginMethod();
      } else {
        this.$router.push(this.$route.query.redirect || "index");
      }
    },
    $route: function(to, from) {
      this.judgeBarShow(to.name);
    }
  }
};
</script>

<style lang="scss" >
@import "./assets/styles/app.scss";
</style>
<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
}
.side-bar {
  position: relative;
  margin: 0;
  width: 200px;
  height: 100%;
  box-shadow: 0 0 2px 2px #f9f9f9;
}
.top-bar {
  position: absolute;
  height: 50px;
  left: 200px;
  top: 0;
  right: 0;
  padding: 0;
  margin: 0;
  box-shadow: 2px 0px 2px 2px #f9f9f9;
}
.content {
  background-color: #f9f9f9;
  position: absolute;
  top: 50px;
  bottom: 0;
  left: 200px;
  right: 0;
  width: calc(100vw - 200px);
  height: calc(100vh - 50px);
  &.noBarContent {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
  }
}
</style>



